import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-sm">
      <Link to="/" className="cursor-pointer text-foreground-500 transition-colors hover:text-primary-700">
        首页
      </Link>
      {items.map((item, index) => (
        <span key={item.label} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-foreground-400"></i>
          {item.to && index < items.length - 1 ? (
            <Link
              to={item.to}
              className="cursor-pointer text-foreground-500 transition-colors hover:text-primary-700"
            >
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-foreground-900">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}